import { useState } from 'react';
import APIs from 'src/api';
import ApprovalProgressDialog from 'src/common/approval/components/ApprovalProgressDialog';
import ApprovalProgressTableCell from 'src/common/approval/components/ApprovalProgressTableCell';
import { usePageConfigProviderContext } from 'src/common/page/PageConfigProvider';
import { Params } from 'src/common/types/GridRenderCellParams';
import { useZusTranslatePrefixStore } from 'src/zustand/store';
import { GetListRes } from '../types/GetListRes';

const useApprovalProgressCell = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { setTranslatePrefix } = useZusTranslatePrefixStore();

  const [selectedRawData, setSelectedRawData] = useState<GetListRes | null>(null);
  const [isApprovalProgressDialogOpen, setIsApprovalProgressDialogOpen] = useState<boolean>(false);
  const renderApprovalProgressCell = ({ row }: Params<GetListRes>) => {
    const { approvalsCount, approvalsRequired, status } = row.rawData;

    return (
      <ApprovalProgressTableCell
        approvalsCount={approvalsCount ?? 0}
        approvalsRequired={approvalsRequired ?? 0}
        applicationStatus={status ?? 0}
        approvedStatus={status ?? 0}
        onButtonClick={() => {
          setSelectedRawData(row.rawData);
          setIsApprovalProgressDialogOpen(true);
          setTranslatePrefix('creditAllocation');
        }}
      />
    );
  };

  const renderApprovalProgressDialog = () => {
    return (
      <ApprovalProgressDialog
        isOpen={isApprovalProgressDialogOpen}
        closeDialog={() => {
          setTranslatePrefix(translatePrefix);
          setIsApprovalProgressDialogOpen(false);
        }}
        id={selectedRawData?.id?.toString() || ''}
        getApproveHistory={APIs.distributorAgentManagement.creditAllocation.getApproveHistory}
      />
    );
  };

  return {
    renderApprovalProgressCell,
    renderApprovalProgressDialog,
  };
};
export default useApprovalProgressCell;
